module.exports = __webpack_public_path__ + "static/media/bg-intro.74e1baa6.jpg";